export function recommendations(state = {}, action) {
  switch (action.type) {
    case 'RECEIVE_USER_RECOMMENDATIONS':
      return {
        ...state,
        [action.payload.userID]: action.payload.recommendations,
      };
    case 'RECEIVE_RECOMMENDATION_CHANGE':
      return {
        ...state,
        [action.payload.userID]: state[action.payload.userID].map(rec => {
          if (rec.id === action.payload.recommendation.id) return action.payload.recommendation;
          return rec;
        }),
      };
    case 'RECEIVE_RECOMMENDATION_BUTTON_CHANGE':
      return {
        ...state,
        [action.recommendation_button.user_id]: state[action.recommendation_button.user_id].map(rec => {
          if (rec.id === action.recommendation_button.recommendation_id) {
            return {
              ...rec,
              buttons: rec.buttons.map(b =>
                b.key === action.recommendation_button.key ? action.recommendation_button : b
              ),
            };
          }
          return rec;
        }),
      };
    default:
      return state;
  }
}
